import styled from '@emotion/styled';

import dynamic from 'next/dynamic';

import PopupNoticeListContainer from './PopupNoticeListContainer';
import MainSectionListContainer
  from '../../../containers/MainSectionListContainer';
import ScrollEventTopButton
  from '../../../../shared/components/Scroll/ScrollEventTopButton';

const FloatingNavigator = dynamic(
  () => import('../../../../navigator/components/FloatingNavigator'),
  { ssr: false },
);

const Container = styled.div`
  position: relative;
  margin-bottom: 40px;
`;

const Content = styled.div`
  position: relative;
`;

export default function MainContainer() {
  return (
    <Container>
      <ScrollEventTopButton>
        <Content>
          <PopupNoticeListContainer/>
          <MainSectionListContainer/>
        </Content>
      </ScrollEventTopButton>
      <FloatingNavigator topFix={516}/>
    </Container>
  );
}
